import isWindow from 'components/common/helpers/isWindow';

const canBeBoolean = (value) => {
  return value === true || value === "true" || value === "1" || value === 1
    || value === false || value === "false" || value === "0" || value === 0
    || value === "";
}

const parseToBoolean = (value) => {
  return value === true || value === "true" || value === "1" || value === 1;
}

const getEnv = (key) => {
  if (isWindow) {
    var envValue = window.env[key];
    if (envValue) {
      if (canBeBoolean(envValue)) {
        return parseToBoolean(envValue);
      } else {
        return envValue;
      }
    } else {
      throw `NOT FOUND ENV: ${key}`;
    }
  } else {
    return '';
  }
}

// defined envs variables:
export const PANEL_URL = getEnv("PANEL_URL");
export const ENABLE_TRACKING = getEnv("ENABLE_TRACKING");
export const GOOGLE_MAPS_API = getEnv("GOOGLE_MAPS_API");
export const GOOGLE_MAPS_GEOCODING_API = getEnv("GOOGLE_MAPS_GEOCODING_API");
export const STRIPE_PK = getEnv("STRIPE_PK");
